const React = require('react');
const { useId } = React;
const { default: MuiDialog } = require('@mui/material/Dialog');
const { default: DialogTitle } = require('@mui/material/DialogTitle');
const { default: DialogContent } = require('@mui/material/DialogContent');
const { default: IconButton } = require('@mui/material/IconButton');
const { default: CloseIcon } = require('@mui/icons-material/Close');

module.exports = function GamificationDialog({ open, onClose, title, closeLabel, descriptionId, children }) {

    const titleId = `gamification-dialog-${useId()}`;
    return <MuiDialog open={open} onClose={onClose} fullWidth maxWidth='xs' aria-labelledby={titleId} aria-describedby={descriptionId}>
        <DialogTitle id={titleId} sx={{ paddingRight: '64px' }}>
            {title}
            <IconButton aria-label={closeLabel} onClick={onClose} size='large' data-focus-outline='radius:40,padding:-4' sx={{ position: 'absolute', top: 8, right: 8, color: 'text.secondary' }}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
    </MuiDialog>;
};
